import { PlaceOrderResponse } from './PlaceOrderResponse'
import { apiClient } from '@slot-nx/core'
import { PlaceOrderRequest } from './PlaceOrderRequest'
import { gameConfig } from '../../../config'
import { bugResult, bugResult2 } from './placeOrderApiMock'

export interface IPlaceOrderApi {
  placeOrder: (input: PlaceOrderRequest) => Promise<PlaceOrderResponse>
}

export const placeOrderApi: IPlaceOrderApi = {
  async placeOrder(input: PlaceOrderRequest): Promise<PlaceOrderResponse> {
    const response = await apiClient.post<PlaceOrderResponse>(`${gameConfig.name}/PlaceOrder`, input)
    return response.data
  },
}

let count = 0

export const mockPlaceOrderApi: IPlaceOrderApi = {
  placeOrder(): Promise<PlaceOrderResponse> {
    count++
    if (count % 2 === 1) {
      return new Promise<PlaceOrderResponse>((resolve) => {
        setTimeout(() => {
          resolve(bugResult)
        }, 1000)
      })
    }
    else {
      return new Promise<PlaceOrderResponse>((resolve) => {
        setTimeout(() => {
          resolve(bugResult2)
        }, 1000)
      })
    }
  },
}
